/**
 * SessionStorage key used by the analytics capture on the root layout to
 * persist marketing / attribution params (utm_*, gclid, etc.) across the
 * signup flow.
 *
 * Lives at the primitive tier (`libs/ui/`) so both the writer
 * (`libs/ui/src/contexts/analytics/index.tsx`) and the reader
 * (`libs/ui/src/utils.ts` `getSignupIntent()`) can agree on the key
 * without either depending on `libs/features`.
 */
export const kAnalyticsSessionParamsKey = 'analytics.session.params';
